<template>
  <section id="home" class="mindset">
    <div class="background"></div>
    <div class="container">
      <div class="row mx-auto">
        <div class="col-10 col-lg-8 offset-1 offset-lg-2">
          <h1 class="text-center fade-in">Unser Mindset</h1>
          <div class="textbox text-center fade-in">
            <p>Wir sind nicht nur auf Haarschnitttechniken spezialisiert, sondern auch
              auf sanfte Colorationen, individuelle Haar- und Kopfhautpflege oder sogar ganze
              Typberatungen. Zum Thema Service, sagen wir: „Back to the Rules!“. Bei uns sind Sie nicht
              nur eine Nummer.</p>
            <p>Besuchen Sie uns – Wir freuen uns auf Sie!</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Mindset"
}
</script>

<style scoped lang="scss">
@import 'src/assets/scss/imports';

.mindset {
  h1 {
    text-transform: uppercase;
    letter-spacing: 4px;
  }

  .fade-in {
    opacity: 0;
    @include transition;

    &.appear {
      opacity: 1;
    }
  }
}
</style>
